import React from 'react';
import styled from 'styled-components';
import Scan from '../../components/Scan/Scan';


const Container = styled.div`
  display: flex;
  flex-direction:row;
  justify-content: space-between;
  width: 100%;
  height: 300px;
  border: none;
  border-radius: 9px;


  background-color: rgba(0,0,0,1);
  overflow:hidden;
  box-shadow: 1px 0px 7px rgba(0, 0, 0, 0.5);
  position: relative;

  @media (max-width: 768px) {
    width:100%;
    height:350px;
  }

`;


const Left = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction:column;
  height: auto;
  float:bottom;
  margin-left:0px;
`;

const Right = styled.div`
  display: flex;
  flex-direction:row;
  height: auto;
  float:bottom;
  width: 50%;
  justify-content: center;
  z-index:0;
  @media (max-width: 768px) {
    margin-right:15px;
    margin-top:15px;
    justify-content:flex-start;
  }

`;

const Inner01 = styled.div`
  display: flex;
  flex-direction:column;
    flex-start;
  width: 50%;
  margin-left:10px;
  margin-top:10px;
  justify-content:left;
  position:absolute;
  z-index:1;

`;

const Tag = styled.span`
  font-size: 0.9rem;
  color: #13F9B2;
  text-transform: uppercase;
  line-height: 1.3;
  letter-spacing: 1px;
    
    justify-content:left;

`;

const Description = styled.p`
  font-family:roboto;
  font-size: 1.5rem;
  font-style: italic;
  font-weight:300;
  color: #ffffff;
  margin: 0.5em 0em 0.4em;
  letter-spacing: .6px;

  
`;

const Paragraph = styled.p`
  font-family:roboto;
  font-size: 0.9rem;
  font-weight:300;
  color: #ffffff;
  margin: 0em 0em 0.9em;
  letter-spacing: .6px;
  z-index:5;

  
`;



const InfoEarthnight = () => (
  
 
  <Container>
    
    <Left>
     <Inner01>
        <Tag>ASK EARTH</Tag>
      
        
        <Description>How will I be affected by climate change?</Description>
        <Paragraph></Paragraph>
        
      
     
    </Inner01>
    
    </Left>
    <Right>
    <Scan/>
   </Right>



  </Container>

  
);

export default InfoEarthnight;